import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const adminApi = axios.create({ baseURL: `${BACKEND_URL}/api/admin` });

adminApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("cit_admin_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

adminApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && typeof window !== "undefined") {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem("cit_admin_token");
        window.location.replace("/admin/login");
      }
    }
    return Promise.reject(err);
  }
);
